import React from "react";

const InStock = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="in-stock-icon"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
      fill="#25A75C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 10.8001L3.2 8.00006L2.26666 8.9334L6 12.6667L14 4.66673L13.0667 3.7334L6 10.8001Z"
      fill="white"
    />
  </svg>
);

export default InStock;
